import { FC } from "react";

export const Asterisk: FC = () => {
  return <span className="text-red-800">*</span>;
};
